
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Radio, Card, Row, Col } from "antd";
import ClaimReports from "./ClaimReports";
import DemographyReport from "./DemographyReport";
import TopTenClaims from "./TopTenClaims";
import EndorsementAnalysis from "./EndrosementAnalysis";
import { getUserData } from "../login/LoginSlice";


const reportOptions = [
  { value: 0, label: "Claim Reports", optionId: 15 },
  { value: 1, label: "Demography Report", optionId: 16 },
  { value: 2, label: "Top Ten Claims", optionId: 17 },
  { value: 3, label: "Endorsement Analysis", optionId: 18 },
];

const Index = () => {
  const [activeComponent, setActiveComponent] = useState(0);
  const [heading, setHeading] = useState("Claim Reports");
  const Data = useSelector(getUserData);

  
  const userModule = Data?.module_data?.find((module) => module.module_id === 11);
  const userOptionIds = userModule?.module_option_ids || [];
  console.log("Allowed Option IDs:", userOptionIds);

  const handleComponentChange = (e) => {
    const component = e.target.value;
    setActiveComponent(component);
    setHeading(reportOptions.find((option) => option.value === component)?.label || "Claim Reports");
  };

  return (
    <div>
      <Row gutter={16}>
        <Col style={{ width: "100%" }}>
          <Card
            className="cust-cd-card mb-3"
            title={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "700",
                  fontSize: "20px",
                }}
              >
                <span className="corp-title">{heading}</span>

                <Radio.Group
                  block
                  onChange={handleComponentChange}
                  defaultValue={0}
                  buttonStyle="solid"
                  optionType="button"
                >
                  {reportOptions.map(({ value, label, optionId }) => (
                    <Radio key={value} value={value} disabled={!userOptionIds.includes(optionId)}>
                      {label}
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            }
            bordered={false}
          ></Card>

          {activeComponent === 0 && <ClaimReports />}
          {activeComponent === 1 && <DemographyReport />}
          {activeComponent === 2 && <TopTenClaims />}
          {activeComponent === 3 && <EndorsementAnalysis />}
        </Col>
      </Row>
    </div>
  );
};

export default Index;